import { Button } from "../ui/button";
import { Download, RotateCcw } from "lucide-react";
import { StepHeader, NavButtons } from "../common";
import { ScoreBoard } from "../ScoreBoard";
import { TreatmentView } from "../TreatmentView";
import { useSession } from "../../lib/session";
import { generatePDF } from "../../lib/pdf";

export default function ReportStep({ scores }) {
  const { state, set, reset } = useSession();
  const p = state.patient;
  return (
    <div>
      <StepHeader num={8} title="Final Report" sub="Download the PDF, then clear the session. Nothing is stored on any server." />
      <div className="flex flex-wrap gap-3 mb-8">
        <Button className="cc-btn" data-testid="btn-download-pdf" onClick={() => generatePDF(state, scores)}><Download className="w-4 h-4 mr-2" />Download PDF report</Button>
        <Button variant="outline" data-testid="btn-finish-new" onClick={() => { if (window.confirm("Clear session and start a new patient?")) reset(); }}><RotateCcw className="w-4 h-4 mr-2" />Start new patient</Button>
      </div>
      <div className="border rounded-md bg-card p-5 mb-6 text-sm" data-testid="report-patient">
        <b>{p.name || "Unnamed patient"}</b> · {p.age} yrs · {p.sex}{p.blood_group && ` · ${p.blood_group} ${p.rh === "Positive" ? "Rh+" : p.rh === "Negative" ? "Rh−" : ""}`} · Chief complaints: {state.history.chief_complaints}
      </div>
      <ScoreBoard s={scores} />
      <div className="mt-6">{state.final && <TreatmentView f={state.final} />}</div>
      <NavButtons onBack={() => set("step", 6)} />
    </div>
  );
}
